p-tabs{flex-grow:1}.p-tabpanels{padding:0}.p-button-outlined{color:#000}@media (min-width: 992px){.p-button-outlined{background-color:#fff;border:1px solid #A2C138;border-radius:8px}}
/*# sourceMappingURL=header.component-ZMR2P6EQ.css.map */
